import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import HeaderTicket from '../components/HeaderTicket'
import HorizontalTicketMenu from '../components/HorizontalTicketMenu'
import Time from '../components/Time'
import TicketContent from '../components/TicketContent'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getVehicleNumberByTrackables,
  getBody,
  resultsToUniqueArray,
  getFleetById,
  getTrackableIds
} from '../utils/trackable'
import {
  getProduct
} from '../utils/helper'
import CircularProgress from '@material-ui/core/CircularProgress'
import config from '../config'
class CheckTicket extends React.Component {
  constructor () {
    super()
    this._isMounted = false
    this.state = {
      data: null,
      keySearch: null
    }
  }

  async componentDidMount () {
    const self = this
    this._isMounted = true
    var product = this.props.match.params.product_id
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(async function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token')).then(function () {
              var newToken = localStorage.getItem('token')
              getUserInfo(newToken)
                .then(response => response.json())
                .then(async function (data) {
                  var products = data.data.attributes.products.fuel_sensor
                  if (getProduct(products, product).length > 0) {
                    var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
                    var fleet = await getFleetById(fleetId)
                    if (fleet) {
                      localStorage.setItem('endpoint', product)
                      let trackableIds = fleet.trackables
                      let fleetName = fleet.name
                      localStorage.setItem('fleetName', fleetName)
                      self.setState({
                        trackableIds: getTrackableIds(trackableIds)
                      })
                      let vehicleNumberList = await getVehicleNumberByTrackables(getTrackableIds(trackableIds))
                      if (vehicleNumberList) {
                        let d = new Date()
                        d.setHours(0, 0, 0, 0)
                        let myDate = d.toJSON()
                        let body = getBody(vehicleNumberList, myDate)
                        self.getVehicleList(body)
                      }
                    } else document.location.href = '/#/error'
                  } else document.location.href = '/#/error'
                })
                .catch((error) => {
                  console.log('error: ', error)
                })
            })
          } else {
            var products = data.data.attributes.products.fuel_sensor
            if (getProduct(products, product).length > 0) {
              var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
              var fleet = await getFleetById(fleetId)
              if (fleet) {
                localStorage.setItem('endpoint', product)
                let trackableIds = fleet.trackables
                let fleetName = fleet.name
                localStorage.setItem('fleetName', fleetName)
                self.setState({
                  trackableIds: getTrackableIds(trackableIds)
                })
                let vehicleNumberList = await getVehicleNumberByTrackables(getTrackableIds(trackableIds))
                if (vehicleNumberList) {
                  let d = new Date()
                  d.setHours(0, 0, 0, 0)
                  let myDate = d.toJSON()
                  let body = getBody(vehicleNumberList, myDate)
                  self.getVehicleList(body)
                }
              } else document.location.href = '/#/error'
            } else document.location.href = '/#/error'
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  getVehicleList (body) {
    fetch(
      `${config.couchdb_final_docs}ToCheckByVehicleAndDate/queries`, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        this.setState({
          data: resultsToUniqueArray(data.results)
        })
      })
      .catch(error => { console.log(error) })
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  render () {
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu
                  enabled='ticket'
                />
              </td>
              <td style={styles.content}>
                <HeaderTicket
                  title='Tickets'
                  getKeySearch={(key) => this.setState({ keySearch: key })}
                />
                <HorizontalTicketMenu
                  enabled='check'
                />
                {/* { this.state.data && this.state.trackableIds
                  ? <TicketContent
                    route='CheckTicket'
                    trackableIds={this.state.trackableIds}
                    data={this.state.data}
                    keySearch={this.state.keySearch}
                  />
                  : <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                } */}
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  }
}

export default CheckTicket
